import { createRoute } from '@tanstack/react-router'
import DocumentsPage from '@/features/documents/pages/DocumentsPage'
import { Route as documentsRoute } from '../documents'

export const Route = createRoute({
  getParentRoute: () => documentsRoute,
  path: '/',
  component: DocumentsPage,
})
